import React, { useEffect, useState } from 'react';
import firebase from 'firebase';
import { trackPromise } from 'react-promise-tracker';
var Web3 = require('web3');

const firebaseConfig = {
    apiKey: "AIzaSyD76mddXoQ6x2X9789YjWnSYys49TQwV54",
    authDomain: "dashboard-backend-4835f.firebaseapp.com",
    databaseURL: "https://dashboard-backend-4835f.firebaseio.com/",
    projectId: "dashboard-backend-4835f",
    storageBucket: "dashboard-backend-4835f.appspot.com",
    messagingSenderId: "191212066284",
    appId: "1:191212066284:web:ecb3ea27b35ce709b01cc9",
    measurementId: "G-FREH608BKT"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const database = firebase.firestore();


const MARKAbi = [  {    "anonymous": false,    "inputs": [      {        "indexed": true,        "internalType": "address",        "name": "_owner",        "type": "address"      },      {        "indexed": true,        "internalType": "address",        "name": "_spender",        "type": "address"      },      {        "indexed": false,        "internalType": "uint256",        "name": "_value",        "type": "uint256"      }    ],    "name": "Approval",    "type": "event"  },  {    "anonymous": false,    "inputs": [      {        "indexed": false,        "internalType": "address",        "name": "_rebaseOracle",        "type": "address"      }    ],    "name": "LogNewRebaseOracle",    "type": "event"  },  {    "anonymous": false,    "inputs": [      {        "indexed": false,        "internalType": "uint256",        "name": "_totalSupply",        "type": "uint256"      }    ],    "name": "LogRebase",    "type": "event"  },  {    "anonymous": false,    "inputs": [      {        "indexed": true,        "internalType": "address",        "name": "_from",        "type": "address"      },      {        "indexed": true,        "internalType": "address",        "name": "_to",        "type": "address"      }    ],    "name": "OwnershipTransferred",    "type": "event"  },  {    "anonymous": false,    "inputs": [      {        "indexed": true,        "internalType": "address",        "name": "_from",        "type": "address"      },      {        "indexed": true,        "internalType": "address",        "name": "_to",        "type": "address"      },      {        "indexed": false,        "internalType": "uint256",        "name": "_value",        "type": "uint256"      }    ],    "name": "Transfer",    "type": "event"  },  {    "constant": false,    "inputs": [],    "name": "acceptOwnership",    "outputs": [],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "spender",        "type": "address"      },      {        "internalType": "uint256",        "name": "value",        "type": "uint256"      }    ],    "name": "approve",    "outputs": [      {        "internalType": "bool",        "name": "",        "type": "bool"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "spender",        "type": "address"      },      {        "internalType": "uint256",        "name": "subtractedValue",        "type": "uint256"      }    ],    "name": "decreaseAllowance",    "outputs": [      {        "internalType": "bool",        "name": "",        "type": "bool"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "spender",        "type": "address"      },      {        "internalType": "uint256",        "name": "addedValue",        "type": "uint256"      }    ],    "name": "increaseAllowance",    "outputs": [      {        "internalType": "bool",        "name": "",        "type": "bool"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "uint256",        "name": "supplyDelta",        "type": "uint256"      },      {        "internalType": "bool",        "name": "increaseSupply",        "type": "bool"      }    ],    "name": "rebase",    "outputs": [      {        "internalType": "uint256",        "name": "",        "type": "uint256"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "newRebaseOracle",        "type": "address"      }    ],    "name": "setRebaseOracle",    "outputs": [],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "to",        "type": "address"      },      {        "internalType": "uint256",        "name": "value",        "type": "uint256"      }    ],    "name": "transfer",    "outputs": [      {        "internalType": "bool",        "name": "",        "type": "bool"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "from",        "type": "address"      },      {        "internalType": "address",        "name": "to",        "type": "address"      },      {        "internalType": "uint256",        "name": "value",        "type": "uint256"      }    ],    "name": "transferFrom",    "outputs": [      {        "internalType": "bool",        "name": "",        "type": "bool"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "constant": false,    "inputs": [      {        "internalType": "address",        "name": "_newOwner",        "type": "address"      }    ],    "name": "transferOwnership",    "outputs": [],    "payable": false,    "stateMutability": "nonpayable",    "type": "function"  },  {    "inputs": [      {        "internalType": "address",        "name": "allocationsContract",        "type": "address"      }    ],    "payable": false,    "stateMutability": "nonpayable",    "type": "constructor"  },  {    "constant": true,    "inputs": [      {        "internalType": "address",        "name": "owner_",        "type": "address"      },      {        "internalType": "address",        "name": "spender",        "type": "address"      }    ],    "name": "allowance",    "outputs": [      {        "internalType": "uint256",        "name": "",        "type": "uint256"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [      {        "internalType": "address",        "name": "who",        "type": "address"      }    ],    "name": "balanceOf",    "outputs": [      {        "internalType": "uint256",        "name": "",        "type": "uint256"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "decimals",    "outputs": [      {        "internalType": "uint8",        "name": "",        "type": "uint8"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "name",    "outputs": [      {        "internalType": "string",        "name": "",        "type": "string"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "newOwner",    "outputs": [      {        "internalType": "address",        "name": "",        "type": "address"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "owner",    "outputs": [      {        "internalType": "address",        "name": "",        "type": "address"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "rebaseOracle",    "outputs": [      {        "internalType": "address",        "name": "",        "type": "address"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "symbol",    "outputs": [      {        "internalType": "string",        "name": "",        "type": "string"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  },  {    "constant": true,    "inputs": [],    "name": "totalSupply",    "outputs": [      {        "internalType": "uint256",        "name": "",        "type": "uint256"      }    ],    "payable": false,    "stateMutability": "view",    "type": "function"  }];



export const DataContext = React.createContext();

const Context = (props) => {

    //charts
    const [vixData, setVixData] = useState([]);
    const [totalSupplyData, setTotalSupplyData] = useState([]);
    const [priceData, setPriceData] = useState([]);
    const [marketCapData, setMarketCapData] = useState([]);
    const [marketCapFDVData, setMarketCapFDVData] = useState([]);

    
    //displayed numbers
    const targetPeg = "1.42930" // fixed for now
    const [vix5DaySMAData, setVix5DaySMAData] = useState([]);
    const [currentVIX, setCurrentVIX] = useState(0);
    const [currentMarketCap, setCurrentMarketCap] = useState(0);
    const [currentFDVMarketCap, setCurrentFDVMarketCap] = useState(0);
    const [currentSupply, setCurrentSupply] = useState(0);
    const [currentCirculatingSupply, setCurrentCirculatingSupply] = useState(0);
    const [livePrice, setLivePrice] = useState(0);
    const [TWAP, setTWAP] = useState(0);
    const [lastRebase, setLastRebase] = useState(0);
    
    // Helper Functions
    const convertEpoch = (epochTime) => {

        const milliseconds = epochTime * 1000

        const dateObject = new Date(milliseconds)

        // const humanDateFormat = dateObject.toLocaleString()
        // console.log(humanDateFormat)

        dateObject.toLocaleString("en-US", { weekday: "long" })
        const month = dateObject.toLocaleString("en-US", { month: "numeric" })
        const day = dateObject.toLocaleString("en-US", { day: "numeric" })
        const year = dateObject.toLocaleString("en-US", { year: "numeric" })
        dateObject.toLocaleString("en-US", { hour: "numeric" })
        dateObject.toLocaleString("en-US", { minute: "numeric" })
        dateObject.toLocaleString("en-US", { second: "numeric" })
        dateObject.toLocaleString("en-US", { timeZoneName: "short" })

        // console.log(`${month}-${day}-${year}`)

        const date = `${year}-${month}-${day}`
        // console.log(date)
        return date
    } 

    // API Calls


    const getVixData = async() => {
       const vixData =  await database.collection('vixdata').orderBy('date', 'asc').get();

       const vixDataArr = vixData.docs.map((x) =>{
            const docData = x.data()
            return { 
                x: convertEpoch(docData.date.seconds), 
                y: docData.VIXfromFed || docData.VIXfromQuandl
            }
       })


          const SMA = (vixDataArr[vixDataArr.length -5].y + vixDataArr[vixDataArr.length -4].y + vixDataArr[vixDataArr.length -3].y + vixDataArr[vixDataArr.length -2].y + vixDataArr[vixDataArr.length -1].y)/5
        //   console.log("SMA", SMA)
          const formattedSMA = SMA.toFixed(2)
        //   console.log(formattedSMA)
        setVix5DaySMAData(formattedSMA)

    //    console.log("VIX", vixDataArr)
        const currentVix = vixDataArr[vixDataArr.length - 1].y
        setCurrentVIX(currentVix)
       return setVixData(vixDataArr)
    } 

    const getLastRebase = async() => {
       const rebaseData =  await database.collection('lastrebase').doc('KlsC3Uwi31I71NNOQOqS').get();
       console.log("REBASE DATA", rebaseData.data().timestamp)
       return setLastRebase(rebaseData.data().timestamp);
    } 


    const getTotalSupplyData = async() => {

        const web3 = new Web3(new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/cd855cb7e2694ff0b477e4dd54397b4c"));
        const markContract = new web3.eth.Contract(MARKAbi, "0x67c597624B17b16fb77959217360B7cD18284253");
        const totalSupplyString = await markContract.methods.totalSupply().call();
        const totalSupply = parseFloat(totalSupplyString);

        const totalSupplyData = await database.collection('supplydata').orderBy('date', 'asc').get()

       let totalSupplyDataArr = totalSupplyData.docs.map((x) =>{
            const docData = x.data()

            const formattedSupply = (docData.MARKTokenSupply / 1000000000000000)
        //    console.log(formattedSupply)
            
            return { 
                x: convertEpoch(docData.date.seconds), 
                y: parseFloat(formattedSupply)
            }
       })


        // most recent chart supply pulled live from blockchain.
        if (totalSupplyDataArr[totalSupplyDataArr.length - 1].y != ( totalSupply / 1000000000000000)){
            
            totalSupplyDataArr.push({x: convertEpoch(Math.round(new Date() / 1000)), y:totalSupply / 1000000000000000})
            console.log("PUSHING", totalSupplyDataArr)
        } else {
            console.log("NOT PUSHING")
            totalSupplyDataArr[totalSupplyDataArr.length - 1].y = ( totalSupply / 1000000000000000)
        }



        const lockedAddreses = [
            '0xAA20E859F4CB7d70ad4270483C2eA5A91665520a',
            '0xab8fde1e00aa24570e18c2b8de0f529bc5ca3f47',
            '0xbddcac70b2053e3274658e65581f329eeecb1553',
            '0x5d9972dd3ba5602574abea6bf9e1713568d49903',
            '0x8335039312b0DDcC5BCC861B70C2a3D735219c69',
            '0x87c8cce0c429772f5b18af388f54dabccb084624',
            '0x1650ed218d4cc3ac3352ff8d5b909198a1729641',
            '0xba700b507f5a2b7e446050b094dcfd22160200f2',
            '0x7da338f1217c480eda31ad2dd02b531e7284091d',
            '0x4b40df51294ac7c046deb8dbcd83030c59dba698',
            '0xf44be6a958d51eab5b5de463b110a295b83cb6b7',
            '0xa94f2a86fb602e8f24ffc556c189396c76b9cd9c',
            '0x8d9791a3e56e1632456ce431cd719a486a82a198',
            '0x2bc118d49fce38e2e24cbdb1999c904fbf2c12a5',
            '0x65bc7ff27d29a56d7ef00eea94c97ebf4c6b9e7f',
            '0x821812ebedc6f13c103679d1f2348bddbf3431de',
            '0xc6a3797482e6ec8491f612900c47927a3dfc30c1',
            '0x820625f689e8a3d699ee0d27879dff2ad2caa44d',
            '0x490daadfdc148545518a94ade35be7575e1116a2',
        ]
        var lockedAmount =0;
        for (var i=0; i<lockedAddreses.length; i++){
            var lockedAmountFromAddressString = await markContract.methods.balanceOf(lockedAddreses[i]).call();
            var lockedAmountFromAddress = parseInt(lockedAmountFromAddressString);
            lockedAmount += lockedAmountFromAddress;
        }
        const circulatingSupply = totalSupply - lockedAmount;


        setCurrentSupply(totalSupply)
        setCurrentCirculatingSupply(circulatingSupply)
        // console.log("circulatingSupply", circulatingSupply)
        // console.log("TTL SUPPLY", totalSupplyDataArr)
       return setTotalSupplyData(totalSupplyDataArr)
    }

    const getPriceData = async() => {

        const livePriceData = await database.collection('liveprice').doc("alzK5Rqd8PLoe9NfeJmt").get()

        const parsedLivePrice = livePriceData.data().price;

        const twapData = await database.collection('twap').doc("Jk4C8cbTXY0fML025Z3M").get()

        const parsedTwap = twapData.data().twap;


        setTWAP(parsedTwap)
        setLivePrice(parsedLivePrice);


        const priceData = await database.collection('pricedata').orderBy('date', 'asc').get()
        var priceDataArr = priceData.docs.map((x) =>{
            const docData = x.data()
            return { 
                x: convertEpoch(docData.date.seconds), 
                y: docData.MARKPriceUniswap || docData.MARKPriceCoingecko 
            }
        })
        try {
            console.log("MATCH DAYS??", priceDataArr[priceDataArr.length -1].x.split("-")[2], (new Date()).getDate())
            if (priceDataArr[priceDataArr.length -1].x.split("-")[2] != (new Date()).getDate()){
                priceDataArr.push({x:convertEpoch((Date.now()/1000)), y:parsedLivePrice})
            }
        } catch (e){
            console.error(e)
        }
    //    console.log("PRICE", priceDataArr)
        return setPriceData(priceDataArr)
    }

    // Helper function for Market Cap API
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const getMarketCapData = async() => {

       const marketCapData = await database.collection('marketdata').orderBy('date', 'asc').get()
       var marketCapDataArr = marketCapData.docs.map((x) =>{
            const docData = x.data()

               var yValue;
               if (docData.marketCap){
                   yValue = (docData.marketCap/1000000).toFixed(2);
                //    console.log("a", yValue)
               } else if (docData.MARKMarketData && docData.MARKMarketData.marketCap) {
                    yValue = (docData.MARKMarketData.marketCap/1000000).toFixed(2);
                    // console.log("b", yValue)
                } else if (docData.MARKMarketData && docData.MARKMarketData.coingeckoMarketCap){
                    yValue = (docData.MARKMarketData.coingeckoMarketCap/1000000).toFixed(2);
                    // console.log("c", yValue)
                }
            return { 
                x: convertEpoch(docData.date.seconds), 
                y: yValue
            }
       })


       var marketCapFDVDataArr = marketCapData.docs.map((x) =>{
            const docData = x.data()

               var yValue;
               if (docData.fullyDilutedMarketCap){
                   yValue = (docData.fullyDilutedMarketCap/1000000).toFixed(2);
                //    console.log("a", yValue)
               } else if (docData.MARKMarketData && docData.MARKMarketData.fullyDilutedValuation) {
                    yValue = (docData.MARKMarketData.fullyDilutedValuation/1000000).toFixed(2);
                    // console.log("b", yValue)
                }
            return { 
                x: convertEpoch(docData.date.seconds), 
                y: yValue
            }
       })

        const livePriceData = await database.collection('liveprice').doc("alzK5Rqd8PLoe9NfeJmt").get()

        const parsedLivePrice = livePriceData.data().price;

        const web3 = new Web3(new Web3.providers.HttpProvider("https://mainnet.infura.io/v3/cd855cb7e2694ff0b477e4dd54397b4c"));
        const markContract = new web3.eth.Contract(MARKAbi, "0x67c597624B17b16fb77959217360B7cD18284253");
        const totalSupplyString = await markContract.methods.totalSupply().call();
        const totalSupply = parseFloat(totalSupplyString);


        const lockedAddreses = [
            '0xAA20E859F4CB7d70ad4270483C2eA5A91665520a',
            '0xab8fde1e00aa24570e18c2b8de0f529bc5ca3f47',
            '0xbddcac70b2053e3274658e65581f329eeecb1553',
            '0x5d9972dd3ba5602574abea6bf9e1713568d49903',
            '0x8335039312b0DDcC5BCC861B70C2a3D735219c69',
            '0x87c8cce0c429772f5b18af388f54dabccb084624',
            '0x1650ed218d4cc3ac3352ff8d5b909198a1729641',
            '0xba700b507f5a2b7e446050b094dcfd22160200f2',
            '0x7da338f1217c480eda31ad2dd02b531e7284091d',
            '0x4b40df51294ac7c046deb8dbcd83030c59dba698',
            '0xf44be6a958d51eab5b5de463b110a295b83cb6b7',
            '0xa94f2a86fb602e8f24ffc556c189396c76b9cd9c',
            '0x8d9791a3e56e1632456ce431cd719a486a82a198',
            '0x2bc118d49fce38e2e24cbdb1999c904fbf2c12a5',
            '0x65bc7ff27d29a56d7ef00eea94c97ebf4c6b9e7f',
            '0x821812ebedc6f13c103679d1f2348bddbf3431de',
            '0xc6a3797482e6ec8491f612900c47927a3dfc30c1',
            '0x820625f689e8a3d699ee0d27879dff2ad2caa44d',
            '0x490daadfdc148545518a94ade35be7575e1116a2',
        ]
        var lockedAmount =0;
        for (var i=0; i<lockedAddreses.length; i++){
            var lockedAmountFromAddressString = await markContract.methods.balanceOf(lockedAddreses[i]).call();
            var lockedAmountFromAddress = parseInt(lockedAmountFromAddressString);
            lockedAmount += lockedAmountFromAddress;
        }
        const circulatingSupply = totalSupply - lockedAmount;


        marketCapDataArr[marketCapDataArr.length - 1].y = (circulatingSupply * parsedLivePrice / 1000000000000000).toFixed(2)

        // console.log("Market cap:",  circulatingSupply, parsedLivePrice)
       
        setCurrentMarketCap(numberWithCommas(marketCapDataArr[marketCapDataArr.length - 1].y))
        setCurrentFDVMarketCap(numberWithCommas((totalSupply * parsedLivePrice / 1000000000000000).toFixed(2)))
        console.log("FDV", totalSupply , parsedLivePrice, (totalSupply * parsedLivePrice / 1000000000000000).toFixed(2), numberWithCommas((totalSupply * parsedLivePrice / 1000000000000000).toFixed(2)) )
        // console.log("marketCap", marketCapDataArr)

        marketCapFDVDataArr[marketCapFDVDataArr.length - 1].y = (totalSupply * parsedLivePrice / 1000000000000000).toFixed(2)

        setMarketCapFDVData(marketCapFDVDataArr)
        //console.log("MARKET CAP FDV", marketCapFDVData, marketCapFDVDataArr )
        return setMarketCapData(marketCapDataArr)
    }
/*
We will do this in a few months, for now just show the SDR/target peg as 1.42

    const getCpiData = async() => {
        const cpiData = await database.collection('cpidata').get()
        cpiData.forEach((doc) => {
            // console.log('CPI Data:', doc.data());
        })
    }
*/

    useEffect(() => {
        // convertEpoch(1607400084)
        
        trackPromise(getTotalSupplyData(), 'supply-graph')
        getPriceData()
        getVixData()
        getLastRebase();
        getMarketCapData()
        console.log("MARKET CAP FDV", marketCapFDVData, marketCapData)
        //getCpiData()

        console.log("LAST REBASE", lastRebase)
    },[])
        





      return (
        <DataContext.Provider value={{vixData, totalSupplyData, priceData, marketCapData, marketCapFDVData, targetPeg, vix5DaySMAData, currentVIX, currentMarketCap, currentFDVMarketCap, currentSupply, currentCirculatingSupply, livePrice, TWAP, lastRebase}}>
          {props.children}
        </DataContext.Provider>
      )
}

export default Context;


